<template lang="pug">
  .table-view
    .table-view-header
      .table-view-header-title
        h3.text-capitalize {{ [date, "DD-MM-YYYY"] | moment('MMMM YYYY') }}
        b-input-group.table-view-header-filter.mr-2
          template(v-slot:prepend)
            .filter-prepend
              font-awesome-icon(:icon="['fas', 'search']")
          b-form-input(v-model="filter" placeholder="buscar")
        b-select.table-view-header-filter(v-model="filterBusinessId")
          b-select-option(:value="null") -- Seleccione un grupo --
          b-select-option(v-for="group in businessGroups" :value="group.businessesIds") {{ group.name }}
      .table-view-header-actions.d-flex.align-items-center
        base-date-select(v-model="date" :max-date="getCurrentPeriod()")
    b-table(
      v-if="businessesMonthlyStates"
      :fields="tableFields"
      :items="filteredItems"
      :filter="filter"
      :filter-included-fields="filterOn"
      head-row-variant="light-primary"
      responsive sticky-header="600px"
    )
      template(v-slot:head(name)="scope")
        div(class="text-nowrap") {{scope.label}}
      template(v-slot:head(rut)="{label}")
        div(style="width: 120px;") {{label}}
      template(v-slot:cell(name)="{item}")
        .d-flex.align-items-center
          router-link(:to="{name:'BusinessDetail', params:{id:item.id} }" style="color:#89AC5B") {{item.name}}
          .note-icon-wrapper.ml-2(v-if="item.client.reminder" v-b-tooltip.hover title="Ver recordatorio" @click="showReminderModal(item)" style="cursor:pointer;")
            font-awesome-icon(:icon="['far', 'comment-dots']" size="lg" style="color: #F6C90E;")
            span.note-badge
      template(v-slot:cell(rut)="row")
        | {{row.item.rut}}
      template(v-slot:cell(options)="{item}")
        div
          b-dropdown(size="sm" variant="primary" boundary="window" class="compact-dropdown" no-caret)
            template(#button-content)
              .flex-grow-1(style="padding: 2px 8px; background-color: rgb(255, 255, 255); border-radius: 100%;")
                font-awesome-icon(:icon="['fas', 'ellipsis-v']" style="transform: rotate(90deg) scale(1.2);")
            b-dropdown-item(@click="lookPasswords(item)")
              font-awesome-icon(:icon="['fas', 'key']" fixed-width class="mr-2" style="color: #8C9195;")
              span Ver claves
            b-dropdown-item(@click="showSendEmailModal(item.client)")
              font-awesome-icon(:icon="['fas', 'envelope']" fixed-width class="mr-2" style="color: #8C9195;")
              span Enviar correo
            b-dropdown-item(@click="showRecepcionarModal(item.client)")
              font-awesome-icon(:icon="['fas', 'download']" fixed-width class="mr-2" style="color: #8C9195;")
              span Rec. Facturas
            b-dropdown-divider
            b-dropdown-item(@click="showReminderModal(item)")
              font-awesome-icon(:icon="['far', 'comment-dots']" fixed-width class="mr-2" :style="{ color: item.client.reminder ? '#F6C90E' : '#8C9195' }")
              span Ver recordatorio
              b-badge(v-if="item.client.reminder" variant="warning" pill class="ml-2" style="font-size:0.65rem;") ●
      template(v-slot:cell()="{item, field}")
        base-service-state-select(
          v-if="item[field.key].state"
          v-model="item[field.key].state"
          @change="updateServiceState(item.id ,$event)"
          :states="field.states"
        )
        base-service-state-select(
          v-else
          placeholder="N/A" 
        )
      template(v-slot:cell(totalProgress)="{item: business}")
        .d-flex
          b-progress.border-secondary(:value="business.totalProgress" style="width: 100px;" variant="secondary")
          .pl-1 {{business.totalProgress}}%
    b-modal.modal(
      v-model="showModal"
      ok-only
    )
      template(#modal-title)
        .title(style="display: inline-flex; align-items: center;")
          font-awesome-icon(:icon="['fas', 'key']" size="lg" style="color: #2B3238;margin-right:10px")
          h3 {{business.client.name}}
      template(#modal-ok) Cerrar
      ModalPasswords(:business="business")
    SendEmailFormModal(ref="sendEmailModal")
    RecepcionarFacturasModal(ref="recepcionarFacturasModal")
    ReminderModal(ref="reminderModal" @reminder-saved="onReminderSaved")
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import BaseServiceStateSelect from './BaseServiceStateSelect'
import BaseDateSelect from '../common/BaseDateSelect'
import ModalPasswords from './ModalPasswords.vue'
import SendEmailFormModal from '../common/SendEmailFormModal'
import RecepcionarFacturasModal from './RecepcionarFacturasModal'
import ReminderModal from './ReminderModal.vue'

export default {
  components: {
    BaseServiceStateSelect,
    BaseDateSelect,
    ModalPasswords,
    SendEmailFormModal,
    RecepcionarFacturasModal,
    ReminderModal
  },
  data () {
    return {
      filterBusinessId: null,
      date: this.getCurrentPeriod(),
      filter: '',
      filterOn: ['name', 'rut'],
      showModal: false,
      business: {}
    }
  },
  methods: {
    ...mapActions(['listServices', 'listBusiness', 'listBusinessGroups']),
    ...mapActions('MonthlyStates',['getMonthlyStates', 'updateBusinessServiceStates']),
    ...mapMutations('MonthlyStates', ['SET_BUSINESSES_MONTHLY_STATES']),
    updateServiceState (businessId, serviceState) {
      const { id: stateId, value, serviceId } = serviceState
      const optionalValue = value ? value : null
      const data = { businessId, stateId, optionalValue, serviceId}
      const date = this.$moment(this.date, 'DD-MM-YYYY')

      this.updateBusinessServiceStates({ data, year: date.year(), month: date.month() + 1 })
    },
    getCurrentPeriod () {
      const date = this.$moment()
      if (date.date() < 25) {
        return date.subtract(1, 'M').date(1).format('DD-MM-YYYY')
      }
      return date.date(1).format('DD-MM-YYYY')
    },
    calculateTotalProgress (businesseStates) {
      if (!businesseStates || !Array.isArray(businesseStates.services)) {
        return 0
      }
      let totalProgress = 0
      let countServices = 0
      businesseStates.services.forEach(service => {
        if (service.state) {
          countServices++
          totalProgress += service.state.pctProgress ? service.state.pctProgress : 0
        }
      })

      const result = Math.round(totalProgress / countServices)
      if (isNaN(result)) {
        return 0
      }
      return result
    },
    lookPasswords(business) {
      this.business= business
      this.showModal=true
    },
    showSendEmailModal (business) {
      this.$refs.sendEmailModal.showModal({ defaultEmail: business.contact, businessId: business.id })
    },
    showRecepcionarModal (business) {
      this.$refs.recepcionarFacturasModal.showModal({ defaultEmail: business.contact, businessId: business.id })
    },
    showReminderModal (item) {
      this.$refs.reminderModal.show(item)
    },
    onReminderSaved ({ id, reminder }) {
      // Actualiza la nota en el ítem local sin recargar la tabla
      const item = this.businessesMonthlyStates.find(b => b.client.id === id)
      if (item) item.client.reminder = reminder
    }
  },
  computed: {
    ...mapGetters(['services','businesses', 'businessGroups']),
    ...mapGetters('AuthenticationStore', ['user']),
    ...mapGetters('MonthlyStates', ['businessesMonthlyStates']),
    filteredItems () {
      const allIds = this.businesses.map(i => i.id)
      const tableItems = this.tableItems.filter(i => allIds.includes(i.id))
      if (this.filterBusinessId) {
        return tableItems.filter(i => this.filterBusinessId.includes(i.id))
      }
      return tableItems
    },
    tableItems () {
      const items = [...this.businessesMonthlyStates]
      items.map(businesseStates => {
        businesseStates.id = businesseStates.client.id
        businesseStates.name = businesseStates.client.name
        businesseStates.rut = businesseStates.client.rut
        businesseStates.services.map(businessServices => {
          businesseStates[businessServices.name] = businessServices
        })
        businesseStates.passwords.map(businessServices => {
          businesseStates[businessServices.name] = businessServices
        })
        businesseStates.passwords.map(businessServices => {
          businesseStates[businessServices.name] = businessServices
        })
        // Añade el progreso total
        businesseStates.totalProgress = this.calculateTotalProgress(businesseStates)
      })
      return items
    },
    activeServices () {
      return this.services.filter(service => {
        if (this.businessesMonthlyStates.length && this.businessesMonthlyStates[0].services.find(ms => ms.id === service.id)) {
          return true
        }
        return false
      })
    },
    tableFields () {
      const fields = [{
        key: 'name',
        label: 'Nombre',
        stickyColumn: true,
        variant: 'light',
        sortable: true
      },
      {
        key: 'rut',
        label: 'Rut',
        sortable: true
      },
      {
        key: 'options',
        label: 'Acciones',
      }]
      this.activeServices.forEach(service => {
        fields.push({ key: service.name, label: service.name,  states: service.states, sortable: true })
      })
      fields.push({ key: 'totalProgress', label: 'Progreso', sortable: true })
      return fields
    }
  },
  watch: {
    // controla la suscripción y desuscripción a eventos del home 
    async date (newValue, oldValue) { 
      const newDate = this.$moment(newValue, 'DD-MM-YYYY')
      await this.getMonthlyStates({ year: newDate.year(), month: newDate.month() + 1 })

      const oldDate = this.$moment(oldValue, 'DD-MM-YYYY')
      this.sockets.unsubscribe(`update state ${oldDate.month() + 1}/${oldDate.year()}`)

      this.sockets.subscribe(`update state ${newDate.month() + 1}/${newDate.year()}`, function(data) {
        this.SET_BUSINESSES_MONTHLY_STATES({ businessesMonthlyStates: data })
      })
    }
  },
  created () {
    this.listBusinessGroups({ params: { userId: this.user.id } })
    this.listBusiness({ params: { userId: this.user.id } })
    const date = this.$moment(this.getCurrentPeriod(), 'DD-MM-YYYY')
    const year = date.year()
    const month = date.month() + 1

    this.sockets.subscribe(`update state ${month}/${year}`, function(data) {
      this.SET_BUSINESSES_MONTHLY_STATES({ businessesMonthlyStates: data })
    })
    this.listServices({ params: { orderBy: 'order' } })
    this.getMonthlyStates({ year, month })
  }
}
</script>

<style scoped>
.compact-dropdown ::v-deep .btn {
  padding: 0.15rem 0.5rem;
  font-size: 0.85rem;
  line-height: 1.2;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
}

::v-deep table th,
::v-deep table td {
  vertical-align: middle !important;
}

.note-icon-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.note-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 8px;
  height: 8px;
  background-color: #F6C90E;
  border-radius: 50%;
  border: 1px solid #fff;
  display: block;
}
</style>
